@if (
  {
    model: model$ | async,
    pending: pendingUi$ | async,
    overlayNs: overlayNs$ | async,
    selectedNodePath: selectedNodePath$ | async,
  };
  as context
) {
  @for (item of items$ | async; track item.element?.id) {
    <div
      class="type-{{ $any(item.element)?.type }}"
      [class.has-slots]="(item.slotNodes.length || 0) > 0"
      [class.loading]="isLoading(item, context.pending || {})"
      [blazeElementNode]="item"
      [blazeRenderElementHost]="item.slotNodes"
      #elementHostRef
    >
      <!-- Editor: Element wrapper (used for action mode) -->
      <ng-container *ngTemplateOutlet="elementWrapperTpl; context: { $implicit: item }" />
      @for (
        slotNode of item.slotNodes;
        track slotNode.slotId;
        let first = $first;
        let last = $last
      ) {
        <ng-template blazeSlotMarker let-elementContext="elementContext">
          <!-- Editor: Left container edge add column handle -->
          <ng-container
            *ngTemplateOutlet="
              columnAddHandleTpl;
              context: { $implicit: item, edge: 'first', slot: slotNode, first: first, last: last }
            "
          />
          <!-- Editor: Right container edge add column handle -->
          <ng-container
            *ngTemplateOutlet="
              columnAddHandleTpl;
              context: { $implicit: item, edge: 'last', slot: slotNode, first: first, last: last }
            "
          />
          <!-- Editor: Left column divider -->
          <ng-container
            *ngTemplateOutlet="
              columnDividerTpl;
              context: {
                $implicit: item.element,
                side: 'left',
                slot: slotNode,
                elements: context.model?.elements,
              }
            "
          />
          <!-- Renderer: Children in this slot -->
          <blaze-nr
            [addRelatedButtonTpl]="addRelatedButtonTpl"
            [columnAddHandleTpl]="columnAddHandleTpl"
            [columnDividerTpl]="columnDividerTpl"
            [columnResizeHandleTpl]="columnResizeHandleTpl"
            [elementContext]="combineContexts(elementContext, item.elementContext)"
            [elements]="context.model?.elements"
            [elementWrapperTpl]="elementWrapperTpl"
            [ids]="getChildrenIds(item.element, slotNode.slotId)"
            [loadingIndicatorTpl]="loadingIndicatorTpl"
            [metadata]="context.model?.metadata"
            [selectionOverlayTpl]="selectionOverlayTpl"
            [selectionToolbarTpl]="selectionToolbarTpl"
            [workflowErrorsTpl]="workflowErrorsTpl"
          />
          <!-- Editor: Right column divider -->
          <ng-container
            *ngTemplateOutlet="
              columnDividerTpl;
              context: {
                $implicit: item.element,
                side: 'right',
                slot: slotNode,
                elements: context.model?.elements || {},
              }
            "
          />
          <!-- Editor: Column resize handle -->
          <ng-container
            *ngTemplateOutlet="
              columnResizeHandleTpl;
              context: { $implicit: item, slot: slotNode, last: last }
            "
          />
          <!-- Editor: Selection toolbar for slot -->
          <ng-container
            *ngTemplateOutlet="
              selectionToolbarTpl;
              context: { $implicit: item, slot: slotNode, elementContext: elementContext }
            "
          />
        </ng-template>
      }
      <!-- Renderer: Current element -->
      <ng-container
        *blazeRenderElement="
          item.element;
          elementHostRef: elementHostRef;
          elementContext: item.elementContext
        "
      />
      <!-- Renderer: Loading indicator -->
      <ng-container
        *ngTemplateOutlet="
          loadingIndicatorTpl;
          context: {
            $implicit: isLoadingWithIndicator(
              item,
              context.pending ?? {},
              context.overlayNs ?? undefined
            ),
          }
        "
      />
      <!-- Editor: Workflow Errors Mark -->
      <ng-container *ngTemplateOutlet="workflowErrorsTpl; context: { $implicit: item }" />
      <!-- Editor: Add Related button -->
      <ng-container *ngTemplateOutlet="addRelatedButtonTpl; context: { $implicit: item }" />
      <!-- Editor: Selection overlay -->
      <ng-container *ngTemplateOutlet="selectionOverlayTpl; context: { $implicit: item }" />
      <!-- Editor: Selection toolbar for element -->
      <ng-container
        *ngTemplateOutlet="
          selectionToolbarTpl;
          context: { $implicit: item, elementContext: item.elementContext }
        "
      />
    </div>
  }
}
